export function datetimeFormatter(val: string): string {
  return String(
    new Date(val).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  );
}

export function percentageFormatter(val: number): string {
  return String(Math.round(val * 10000) / 100) + "%";
}

export function ntFormatter(val: number): string {
  return String(val.toLocaleString()) + " nt";
}

export function depthFormatter(val: number): string {
  return String(val.toLocaleString()) + "×";
}

export function renderTagTooltip(tagName: string): string | undefined {
  switch (tagName) {
    case "Type Strain":
      return `Strain with official standing in prokaryotic nomenclature;
    in essence the 'definition' of the species`;
    case "MSA Component":
      return "Component of an ATCC® Microbiome Standard";
    case "GPS":
      return "Isolate from the ATCC® Global Priority Superbugs collection";
  }
  return;
}
